import { Skeleton } from "./skeleton";

export const SkeletonBanner = () => {
  return (
    <div className="max-lg:mt-1">
      <Skeleton className="w-full h-[205px] sm:h-[337px] rounded-md bg-sivarbet-border" />
    </div>
  );
};
